import {post} from '@/utils/request';

//获取登陆人的菜单权限
export async function getMenuoperation(params) {
    return post('/menu/initMenu', params, true)
}
//注销用户
export async function logout(params) {
    return post('/login/logout', params, true)
}

